import React from 'react'
import styles from './Styles.jsx'
import {
  Button,
  Container,
  // Divider,
  // Grid,
  Header,
  Icon,
  // Image,
  // List,
  // Menu,
  Segment,
  // Visibility,
} from 'semantic-ui-react'

const Contacts = () => (
  <section id='contacts'>
      <Segment style={styles.sectionGrey}>
        <Container>
        <Header as='h1'  style={styles.h} content='Want to start a project?' />
        <Header as='h4'  style={styles.h3} content='Send us a message and let us know what you want to create.' />
        {/* <div style={styles.contacts}>
           <a href=''><Icon name='mail outline' /> info@rownarts.com</a>
        </div> */}

        <a href='mailto:info@rownarts.com'>
          <Button primary size='huge'>
            <Icon name='mail outline' />
            info@rownarts.com
          </Button>
        </a>

        <br/><br/>

        {/* <Grid textAlign='center'>
          <Grid.Row style={styles.contacts}>
            <Grid.Column computer={8} mobile={16}>
              <Header as='h4'  style={styles.h4} content='EMAIL' />
              <a href='mailto:info@rownarts.com'>info@rownarts.com</a><br/><br/>
            </Grid.Column>
            <Grid.Column computer={8} mobile={16} >

              <Header as='h4'  style={styles.h4} content='PHONE' />
              +7 910 446 8130

            </Grid.Column>
          </Grid.Row>
        </Grid> */}


{/* <iframe 
src="https://services.cognitoforms.com/f/bjq_j6IPx0-xGXUTIYlDeA?id=1" 
style={{position:'relative', width:1, minWidth:'100%'}} 
frameborder="0" scrolling="yes" seamless="seamless" height="369" width="100%">
</iframe>
<script src="https://services.cognitoforms.com/scripts/embed.js"></script>         */}


        </Container>
    </Segment>

  </section>


)
export default Contacts



// WEBPACK FOOTER //
// ./src/components/Contacts.jsx